<template>
    <span
        :title="date"
        :class="{
            'text-green-500' : showState && goodState(date),
            'text-orange-400': showState && warningState(date),
            'text-red-600': showState && dangerState(date),
        }">
           {{ output }}
    </span>
</template>

<script>

import dayjs from "dayjs";

export default {

    name: "Calendar Format",

    props: {
        date: {},
        showState: {
            type: Boolean,
            default: false
        },
        goodState: {
            default: () => date => date && dayjs(date).isAfter(dayjs().add(1, 'day').startOf('day'))
        },
        warningState: {
            default: () => date => date && dayjs(date).isToday() && dayjs(date).isBefore(dayjs())
        },
        dangerState: {
            default: () => date => date && dayjs(date).isBefore(dayjs())
        },
    },

    computed: {
        output() {
            return this.date ? dayjs(this.date).calendar(null, {sameElse: 'DD/MM/YYYY h:mm A'}) : '-';
        }
    }
};

</script>
